import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyAxios, handleError, handleResponse } from '@services/SettingAxios';

export const getKamaContent = createAsyncThunk('brand/getKamaContent', async () => {
  return await MyAxios.get('/api/misc-service/get-static?code=kama-tyres-desc').then(handleResponse).catch(handleError);
});
